export default {
  path: '/training',
  name: 'Training',
  redirect: '/training/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/training'),
      meta: { requiresAuth: true }
    },
    {
      path: 'addPlain',
      component: () => import('@/views/training/AddPlain'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detail',
      component: () => import('@/views/training/PlainDetail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'coach_plan_list',
      component: () => import('@/views/training/CoachPlanList'),
      meta: { requiresAuth: true }
    },
  ]
}
